import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-illustration">
          <svg
            viewBox="0 0 200 200"
            className="not-found-svg"
            aria-hidden="true"
          >
            <circle cx="100" cy="100" r="80" fill="none" stroke="currentColor" strokeWidth="4" opacity="0.3" />
            <path
              d="M70 70 L130 130 M130 70 L70 130"
              stroke="currentColor"
              strokeWidth="6"
              strokeLinecap="round"
            />
            <text x="100" y="180" textAnchor="middle" className="not-found-text">
              404
            </text>
          </svg>
        </div>
        
        <div className="not-found-content">
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-description">
            Sorry, we couldn't find the page you're looking for. The page may have been moved, deleted, 
            or you may have typed the URL incorrectly.
          </p>
          
          <div className="not-found-actions">
            <button 
              onClick={handleGoBack}
              className="btn btn-secondary"
            >
              <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
              Go Back
            </button>
            
            <Link to="/dashboard" className="btn btn-primary">
              <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
              </svg>
              Go to Dashboard
            </Link>
          </div>
          
          <div className="helpful-links">
            <h3>Helpful Links</h3>
            <ul>
              <li><Link to="/dashboard">Production & Inventory Overview</Link></li>
              <li><Link to="/financial-analysis">Financial Analysis</Link></li>
              <li><Link to="/documentation">Documentation</Link></li>
              <li><Link to="/support">Support</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;